import React, { useEffect } from "react";

import { Box } from "@mui/material";
import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";
import { useDialogs } from "@src/hooks/dialog";
import pattern from "@src/images/igLogo/pattern-logo.png";

export const NotSubscribedRoute = () => {
  const { openDialog } = useDialogs();

  useEffect(() => {
    setTimeout(() => openDialog("onboarding"), 500);
  }, []);

  return (
    <>
      <NavigationDrawer isUnauthorized={true} />
      <Box
        className={"pattern-background"}
        sx={{
          margin: "-8px",
          height: "100vh",
          opacity: ".65",
          width: "100vw",
          backgroundImage: `url(${pattern})`,
        }}
      ></Box>
    </>
  );
};
